import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import cn from "classnames";
import { BsArrowRightCircleFill } from "react-icons/bs";

export const FeatureSplit = ({
  className,
  title,
  content,
  items,
  reverse,
  background,
  buttonLink,
  buttonTitle,
}) => {
  return (
    <section
      className={cn(
        styles.FeatureSplit,
        className,
        reverse && styles.reverse,
        styles[background]
      )}
    >
      <Container className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {title && <h2 data-sourceflow-prop="title">{title}</h2>}
            {content && (
              <div
                data-sourceflow-prop="content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            {buttonLink && buttonTitle && (
              <div className="mt-4">
                <a
                  href={buttonLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="primaryBtn no-arrow m-0"
                >
                  {buttonTitle}
                </a>
              </div>
            )}
          </div>
          <div className={styles.itemList}>
            {items?.map((item, i) => (
              <a
                href={item?.url || "#"}
                className={cn(
                  styles.item,
                  item.variant === "yellowWhite"
                    ? styles.yellowBox
                    : styles.blackBox
                )}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item?.icon?.url && <img src={item.icon.url} alt="" />}
                <div className={styles.texts}>
                  <h4>{item.title}</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}
                  />
                </div>
                <BsArrowRightCircleFill />
              </a>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FeatureSplit;
